import * as API from 'core/api';
import { Bus } from 'core/infrastructure';
import { AppointmentForEditionDTO, TicketLocationDTO, TicketDTO } from 'core/api';

const process = Bus.buildProcessFn('/bus/');

export function getMonthlyAppointments(currentDate: Date, from: Date, to: Date): Promise<API.MonthlyAppointmentsDTO> {
	const request = new API.GetMonthlyAppointmentsRequest({ currentDate, from, to });
	return process(request, (response: API.GetMonthlyAppointmentsResponse) => response.Calendar);
}

export async function createAt(date: Date): Promise<AppointmentForEditionDTO> {
	const request = new API.CreateAppointmentRequest({ date });
	return process(request, (response: API.CreateAppointmentResponse) => response.Appointment);
}

export function save(appointment: AppointmentForEditionDTO): Promise<void> {
	const request = new API.SaveAppointmentRequest({ appointment });
	return process(request);
}

export async function edit(id: number): Promise<API.AppointmentForEditionDTO> {
	const request = new API.EditAppointmentRequest({ id });
	return process(request, (response: API.EditAppointmentsResponse) => response.Appointment);
}

export function remove(appointmentId: number): Promise<void> {
	const request = new API.DeleteAppointmentRequest({ appointmentId });
	return process(request);
}

export function cancel(appointmentId: number): Promise<void> {
	const request = new API.CancelAppointmentRequest({ appointmentId });
	return process(request);
}

export function close(appointmentId: number, location: TicketLocationDTO): Promise<TicketDTO> {
	const request = new API.CloseAppointmentRequest({ appointmentId, location });
	return process(request, (response: API.CloseAppointmentResponse) => response.Ticket);
}
